import {Component, OnInit, Optional} from '@angular/core';
import {DialogBase} from '@shared/helper/dialog-base';
import {DynamicDialogConfig, DynamicDialogRef} from 'primeng/dynamicdialog';
import {SectionModel} from '@app/models/section';
import {CourseModel} from '@app/@core/domain/course.model';
import {TicketModel} from '@app/models/ticket';
import Section = SectionModel.Section;

interface SectionEditDialogData {
    section: Section;
}

@Component({
    selector: 'app-section-edit-dialog',
    templateUrl: './section-edit-dialog.component.html',
    styleUrls: ['./section-edit-dialog.component.scss']
})
export class SectionEditDialogComponent extends DialogBase<SectionEditDialogData, Section> implements OnInit {
    section: Section;

    constructor(
        @Optional() public ref: DynamicDialogRef,
        @Optional() public config: DynamicDialogConfig
    ) {
        super(ref, config);
    }

    ngOnInit(): void {
        this.section = this.config.data.section;
    }

    closeDialog(section: Section) {
        this.close(section);
    }
}
